import { useMemo, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, GradeLevelOptions, GradeOptions, FilterOptions, getGradeOptions, TermFilter } from "../../../../../../_helpers/Helpers";
import { useGradeAndSectionReportUIContext } from "../GradeAndSectionReportUIContext";

const prepareFilter = (queryParams, values) => {
  let { term, gradeLevel, grade, name, maleStudentCount, femaleStudentCount, other } = values;
  maleStudentCount = maleStudentCount === "" ? null : maleStudentCount;
  femaleStudentCount = femaleStudentCount === "" ? null : femaleStudentCount;
  other = other === "" ? null : other;
  const newQueryParams = { ...queryParams };
  const filter = { gradeLevel, grade, name, maleStudentCount, femaleStudentCount, other };
  newQueryParams.filter = filter;
  newQueryParams.term = term;
  return newQueryParams;
};

export function GradeAndSectionReportFilter() {
  const [gradeOptions, setGradeOptions] = useState(FilterOptions.concat(GradeOptions));

  // Grade and Section Report UI Context
  const gradeAndSectionReportUIContext = useGradeAndSectionReportUIContext();
  const gradeAndSectionReportUIProps = useMemo(() => {
    return {
      setQueryParams: gradeAndSectionReportUIContext.setQueryParams,
      queryParams: gradeAndSectionReportUIContext.queryParams,
    };
  }, [gradeAndSectionReportUIContext]);
  
  const { currentActiveTerm } = useSelector(
    (state) => ({
      currentActiveTerm: state.auth.user.currentActiveTerm
    }),
    shallowEqual
  );

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(gradeAndSectionReportUIProps.queryParams, values);
    if (!isEqual(newQueryParams, gradeAndSectionReportUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      gradeAndSectionReportUIProps.setQueryParams(newQueryParams);
    }
  };

  const gradeLevelOptions = FilterOptions.concat(GradeLevelOptions)
  
  return (
    <Formik
      initialValues={{
        term: currentActiveTerm,
        name: "",
        maleStudentCount: "",
        femaleStudentCount: "",
        other: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        handleChange,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <TermFilter
            handleSubmit={handleSubmit}
            handleBlur={handleBlur}
            handleChange={handleChange}
            values={values}
          />
          <div className="form-group row">
            <div className="col-lg-2">
              <CustomSelect 
                options={gradeLevelOptions}
                value={values.gradeLevel}
                placeholder="Sınıf Düzeyi"
                onBlur={handleBlur}
                onChange={e => {
                  if (e.value === undefined) {
                    setGradeOptions(FilterOptions.concat(GradeOptions));
                    setFieldValue("grade", undefined);

                  } else {
                    const options = getGradeOptions(e.value);

                    if (options.length === 1) {
                      setGradeOptions(options);
                      setFieldValue("grade", options[0].value);

                    } else {
                      setGradeOptions(FilterOptions.concat(options));
                      if (!options.map(option => option.value).includes(values.grade)) setFieldValue("grade", undefined);
                    }
                  }
                  setFieldValue("gradeLevel", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıf Düzeyi</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={gradeOptions}
                value={values.grade}
                placeholder="Sınıf"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("grade", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıf</b>
              </small>
            </div>            
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Şube"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Şube</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="maleStudentCount"
                min={1}
                placeholder="Erkek"
                onBlur={handleBlur}
                value={values.maleStudentCount}
                onChange={(e) => {
                  setFieldValue("maleStudentCount", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Erkek</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="femaleStudentCount"
                min={1}
                placeholder="Kız"
                onBlur={handleBlur}
                value={values.femaleStudentCount}
                onChange={(e) => {
                  setFieldValue("femaleStudentCount", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kız</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="other"
                min={1}
                placeholder="Diğer"
                onBlur={handleBlur}
                value={values.other}
                onChange={(e) => {
                  setFieldValue("other", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Diğer</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}